"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NunjucksTransformer = NunjucksTransformer;
const nunjucks_1 = require("nunjucks");
const omit_1 = __importDefault(require("lodash/omit"));
const env = new nunjucks_1.Environment(null, {
    autoescape: false,
});
env.addFilter('json', function (val) {
    return JSON.stringify(val, null, 2);
});
env.addFilter('filterKeys', function (val, keys) {
    keys = Array.isArray(keys) ? keys : [keys];
    return (0, omit_1.default)(val, keys);
});
function NunjucksTransformer(options) {
    return data => { };
}
//# sourceMappingURL=nunjucks-transformer.js.map